import { ExpandLess, ExpandMore, FilterTiltShift } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface ITire {
  setOpen: (value: boolean) => void;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  drawerIsOpen: boolean;
}

export const Tire = (props: ITire) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.entities.tire">Tire</Translate>} placement="right">
        <ListItemButton
          id="tire-button"
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: props.isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <FilterTiltShift />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.entities.tire">Tire</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => props.setOpen(false)}>
          <MenuItem icon="asterisk" to="/tire-custom/tire-indicators">
            <Translate contentKey="global.menu.entities.tireIndicators" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/tire">
            <Translate contentKey="global.menu.entities.tire" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/tire-model">
            <Translate contentKey="global.menu.entities.tireManufacturerModel" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/tire-tread-model">
            <Translate contentKey="global.menu.entities.tireTread" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/tire-alert-setting">
            <Translate contentKey="global.menu.entities.tireAlertSetting" />
          </MenuItem> 
        </List>
      </Collapse>
    </>
  );
};
